import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isEmpty } from "lodash";
import { memo, useEffect, useRef, useState } from "react";
import { useAppSelector } from "../../hooks/redux";
import styles from "./step-number.module.scss";
const StepNumberInput = ({ component, isFocus, formType, timeType, productType, inputLabel, defaultValue, stepInput, errorMessage, showError, allowZero, returnValue, disabled, placeholder, errorMessageCallback, min, scripNameChange, errorInfo, scripNameChangeCallBack, toolTipErrorMessage, isBuyForm, maxLength = 9, showMultipler, maxValueAllowed = 999999999, minValueAllowed = 0, isBulk, }) => {
    const qtyRef = useRef();
    const [noOfRetry, setNoOfRetry] = useState(0);
    const [custInput, setCustInput] = useState(() => defaultValue);
    const [stateErrorMessage, setStateErrorMessage] = useState("");
    const [stateDisabled, setStateDisabled] = useState(disabled);
    const bulkOrderPlacement = useAppSelector((state) => {
        return state.modals.bulkOrderPlacement;
    });
    const setErrorMessage = (stockQty) => {
        const modulus = stockQty % stepInput;
        // if (isNaN(modulus) || (modulus == 0 && (stockQty > 0 || allowZero))) {
        //   setStateErrorMessage("");
        //   if (errorMessageCallback) errorMessageCallback("");
        // } else {
        //   setStateErrorMessage(errorMessage);
        //   if (errorMessageCallback) errorMessageCallback(errorMessage);
        // }
        if (isNaN(modulus)) {
            setStateErrorMessage("");
            if (errorMessageCallback)
                errorMessageCallback("");
        }
        else if (showError) {
            setStateErrorMessage(errorMessage);
            if (errorMessageCallback)
                errorMessageCallback(errorMessage);
        }
        else if (modulus == 0 && (stockQty > 0 || allowZero)) {
            setStateErrorMessage("");
            if (errorMessageCallback)
                errorMessageCallback("");
        }
        else {
            setStateErrorMessage(errorMessage);
            if (errorMessageCallback)
                errorMessageCallback(errorMessage);
        }
    };
    const setCustInputCallBack = (event, isBlur) => {
        if (isBlur) {
            setErrorMessage(custInput);
            if ((event == "" || event == "0") && minValueAllowed) {
                setCustInput(minValueAllowed);
            }
        }
        else if (isEmpty(event)) {
            setCustInput(0);
        }
        else if (min !== undefined && event.toString().length > min) {
            return;
        }
        else {
            setCustInput(parseInt(event));
        }
    };
    useEffect(() => {
        if (min !== undefined) {
            setCustInput(1);
            scripNameChangeCallBack === null || scripNameChangeCallBack === void 0 ? void 0 : scripNameChangeCallBack();
        }
    }, [scripNameChange]);
    useEffect(() => {
        setCustInput(defaultValue);
    }, [defaultValue]);
    useEffect(() => {
        setErrorMessage(custInput);
    }, [custInput, errorMessage, showError]);
    useEffect(() => {
        if (stepInput == 0) {
            setStateDisabled(true);
        }
        else {
            setStateDisabled(disabled);
        }
    }, [stepInput, disabled]);
    const countUpCallback = () => {
        if (stateDisabled) {
            return;
        }
        let newInput = parseInt(custInput + "") + Number(stepInput);
        if (newInput >= maxValueAllowed + 1) {
            return;
        }
        const modulus = newInput % stepInput;
        newInput = newInput - modulus;
        setCustInput(newInput);
        setErrorMessage(newInput);
    };
    const countDownCallback = () => {
        if (stateDisabled) {
            return;
        }
        if (custInput > 0 || allowZero) {
            let newInput = parseInt(custInput + "") - stepInput;
            const modulus = newInput % stepInput;
            newInput = newInput - modulus;
            if (newInput >= 0 && (newInput > 0 || allowZero)) {
                setCustInput(newInput);
                setErrorMessage(newInput);
            }
        }
    };
    useEffect(() => {
        returnValue(custInput);
        return () => {
            qtyRef.current = undefined;
        };
    }, [custInput]);
    //test
    // setInterval(()=>setCount(1),1000);
    // useEffect(() => {
    //   if (isFocus) {
    //     setTimeout(() => {
    //       getFocus();
    //     }, 100);
    //   }
    // }, [custInput, productType, timeType, formType, noOfRetry]);
    const getFocus = () => {
        if (qtyRef.current && document.activeElement != qtyRef.current) {
            // console.log(document.activeElement, " active element");
            // console.log(qtyRef.current, " qtyRef");
            // console.log("This is a tribue.");
            // qtyRef.current.focus();
            if (noOfRetry < 10) {
                setNoOfRetry(noOfRetry + 1);
                qtyRef.current.select();
            }
        }
    };
    return (_jsxs("div", Object.assign({ className: `${styles.qntyInput} qntyInputStratzy` }, { children: [inputLabel && _jsx("label", { children: inputLabel }), _jsxs("div", Object.assign({ className: `${styles.qntyInputField} ${disabled ? styles.qntyInputDisable : ""} qntyInputFieldStratzy d-flex align-items-center input-groupa mt-2` }, { children: [_jsx("input", { ref: qtyRef, type: "number", placeholder: placeholder ? "" : inputLabel, className: `${styles.formControl} ${(isBulk || isBuyForm) && stateErrorMessage ? styles.inputError : ""}`, "aria-label": "", value: custInput + "", min: stepInput, step: stepInput, 
                        // onWheel={(event: any) => {
                        //   event.target.blur();ss
                        // }}
                        disabled: stateDisabled, onChange: (event) => {
                            // if (showMultipler) {
                            //   parseInt(event.target.value) <= 100 || event.target.value == ""
                            //     ? setCustInputCallBack(event.target.value, false)
                            //     : "";
                            // } else {
                            //   event.target.value.length < maxLength + 1
                            //     ? setCustInputCallBack(event.target.value, false)
                            //     : "";
                            // }
                            Number(event.target.value) <= maxValueAllowed
                                ? setCustInputCallBack(event.target.value, false)
                                : "";
                        }, onBlur: (event) => setCustInputCallBack(event.target.value, true) }), _jsxs("div", Object.assign({ className: `${styles.countWrapper} countWrapper`, "data-testid": "countWrapper" }, { children: [_jsx("span", { className: `${styles.countMinus} input-group-text-bk`, "data-testid": "countMinus", onClick: countDownCallback }), _jsx("span", { className: `${styles.countPlus} input-group-text-bk`, "data-testid": "countPlus", onClick: countUpCallback })] }))] })), _jsxs("p", Object.assign({ className: `${styles.errorText} mt-2 mb-0 errorTextHoldings`, hidden: stateErrorMessage == "" || errorMessageCallback != undefined }, { children: [stateErrorMessage, errorInfo && (_jsx("div", Object.assign({ className: "ms-1 warningCircleIcon tooltipParent" }, { children: _jsx("p", Object.assign({ className: "tooltipBox tooltipBoxSm tooltipBoxRight" }, { children: toolTipErrorMessage })) })))] }))] })));
};
export default memo(StepNumberInput);
